import {Nullish} from 'shared/web';

import {EmailWithWarning} from '../components/EmailWithWarning/EmailWithWarning';
import {isInvalidEmail} from './isInvalidEmail';

/** The value of an attribute row for a stored e-mail; one the DMS API refuses shows a warning. */
export const getEmailAttribute = (email: string | Nullish) =>
  isInvalidEmail(email)
    ? {content: <EmailWithWarning email={email} data-testid="storedEmail" />}
    : {value: email};
